<div class="card mb-5"> 
  <div class="card-body">
    <div id="{{data.widgetId}}" style="height: 65vh;"></div>
  </div>
</div>